import { createEnv } from "@t3-oss/env-nextjs"
import { z } from "zod"

export const env = createEnv({
  server: {
    DATABASE_URL: z.string().url(),
    DATABASE_SSL: z.enum(["true", "false"]).optional(),
    NODE_ENV: z
      .enum(["development", "test", "production"])
      .default("development"),
    BETTER_AUTH_SECRET: z.string().min(32),
    BETTER_AUTH_URL: z.string().url().optional(),
    NOTION_TOKEN: z.string(),
    NOTION_DATABASE_ID: z.string(),
    PRIVATE_POST_PASSWORD: z.string().min(1),
    // Optional: without it, book search uses the keyless per-IP quota and
    // falls back to Open Library when that runs out.
    GOOGLE_BOOKS_API_KEY: z.string().min(1).optional(),
    // Optional: without it, generating spine images for the bookshelf is
    // unavailable and books keep their drawn spines.
    OPENROUTER_API_KEY: z.string().min(1).optional(),
    // Optional: without it, the cover refetch cannot upscale the covers too
    // small to show on a book taken off the shelf, and refuses to run.
    FAL_KEY: z.string().min(1).optional(),
    // Set by Vercel at runtime; sizes the database pool for serverless.
    VERCEL_ENV: z.enum(["production", "preview", "development"]).optional(),
  },
  client: {
    NEXT_PUBLIC_APP_URL: z.string().url().default("http://localhost:3000"),
    // Optional on purpose: without a key the app renders identically and sends
    // nothing. Local dev, PR previews and CI builds all run without one, so a
    // missing key must never be a build failure.
    NEXT_PUBLIC_POSTHOG_KEY: z.string().min(1).optional(),
    NEXT_PUBLIC_POSTHOG_HOST: z
      .string()
      .url()
      .default("https://eu.i.posthog.com"),
  },
  runtimeEnv: {
    DATABASE_URL: process.env.DATABASE_URL?.trim(),
    DATABASE_SSL: process.env.DATABASE_SSL?.trim(),
    NODE_ENV: process.env.NODE_ENV?.trim(),
    BETTER_AUTH_SECRET: process.env.BETTER_AUTH_SECRET?.trim(),
    BETTER_AUTH_URL: process.env.BETTER_AUTH_URL?.trim(),
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL?.trim(),
    NEXT_PUBLIC_POSTHOG_KEY: process.env.NEXT_PUBLIC_POSTHOG_KEY?.trim(),
    NEXT_PUBLIC_POSTHOG_HOST: process.env.NEXT_PUBLIC_POSTHOG_HOST?.trim(),
    NOTION_TOKEN: process.env.NOTION_TOKEN?.trim(),
    NOTION_DATABASE_ID: process.env.NOTION_DATABASE_ID?.trim(),
    PRIVATE_POST_PASSWORD: process.env.PRIVATE_POST_PASSWORD?.trim(),
    GOOGLE_BOOKS_API_KEY: process.env.GOOGLE_BOOKS_API_KEY?.trim(),
    OPENROUTER_API_KEY: process.env.OPENROUTER_API_KEY?.trim(),
    FAL_KEY: process.env.FAL_KEY?.trim(),
    VERCEL_ENV: process.env.VERCEL_ENV?.trim(),
  },
  skipValidation: !!process.env.SKIP_ENV_VALIDATION,
  emptyStringAsUndefined: true,
})
